import { useCallback, useState } from "react";
import { useITwinEventsServiceV1API } from "../useITwinEventsServiceV1API/useITwinEventsServiceV1API";
import { IDataCentersResponse } from "../../interfaces/IDataCenter";

export const useGetDataCenters = (): [
  IDataCentersResponse | undefined,
  boolean,
  Error | undefined,
  () => Promise<IDataCentersResponse | undefined>
] => {
  const [data, setData] = useState<IDataCentersResponse>();

  const { get, response, loading, error } = useITwinEventsServiceV1API<IDataCentersResponse>("discovery", true);

  const getDataCenters = useCallback(
    async () => {
      const dataCentersResponse = await get("/datacenters");

      if (response.ok) {
        setData(dataCentersResponse);
      }

      return dataCentersResponse;
    },
    [get, response]
  );

  return [data, loading, error, getDataCenters];
};
